import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { PageComponent } from './page/page.component';

const routes: Routes = [
  { path: '', component: PageComponent, data: { page: 'home' }, pathMatch: 'full' },
  { path: 'services', component: PageComponent, data: { page: 'services' } },
  { path: 'asset-management', component: PageComponent, data: { page: 'asset-management' } },
  { path: 'ecommerce', component: PageComponent, data: { page: 'ecommerce' } },
  { path: 'erp', component: PageComponent, data: { page: 'erp' } },
  { path: 'career-platform', component: PageComponent, data: { page: 'career-platform' } },
  { path: 'property-platform', component: PageComponent, data: { page: 'property-platform' } },
  { path: 'privacy-policy', component: PageComponent, data: { page: 'privacypolicy' } },
  { path: 'terms-of-service', component: PageComponent, data: { page: 'termsofservice' } },
  { path: '**', redirectTo: '' }
];

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    PageComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled'
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
